import {selectDomain} from '.';
import {createSelector} from '@reduxjs/toolkit';

export default (name: string) =>
  createSelector(selectDomain, listing => {
    const vals = listing.deletedResources[name];
    return Object.values(vals ?? {}).length;
  });
